import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { exportArrayToCsv } from '@/lib/csvExport';
import { ewbApi } from '@/services/ewayBillApi';

const COLS = [{ key: 'transfer_id', header: 'Internal Transfer No' }, { key: 'processing_unit', header: 'Processing Unit' }, { key: 'bundles', header: 'Bundles' }];

/** CSV of this section's internal transfers with a Processing Unit assigned and no e-way bill yet — to get the shipment ready for transport. */
export const TransfersToShipCsv = ({ section }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const rows = await ewbApi.transfersToShip({ section });
      if (!rows.length) { toast.info('No transfers waiting for transport — none here has a processing unit without an e-way bill'); return; }
      const day = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
      exportArrayToCsv(rows, COLS, `transfers_to_ship_${(section || 'all').replace(/[^A-Za-z0-9]+/g, '_')}_${day}.csv`);
      toast.success(`Exported ${rows.length} transfer${rows.length === 1 ? '' : 's'} ready for transport`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not export');
    } finally { setBusy(false); }
  };
  return (
    <Button size="sm" variant="outline" className="h-8 text-xs" onClick={run} disabled={busy} data-testid="ewb-transfers-to-ship-csv">
      {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Download className="w-3.5 h-3.5 mr-1" />}Export CSV
    </Button>
  );
};

export default TransfersToShipCsv;
